import { listCategoriesService } from "../../../services/categories";
import {
  CATEGORIES_ERROR,
  CATEGORIES_LIST,
  CATEGORIES_LOADING,
} from "../types";

export const getCategoriesAction =
  ({ page, limit }) =>
  (dispatch) => {
    dispatch({ type: CATEGORIES_LOADING });

    return listCategoriesService({ page, limit })
      .catch((e) =>
        dispatch({
          type: CATEGORIES_ERROR,
          payload: e,
        })
      )
      .then((d) => {
        if (d?.error)
          return dispatch({
            type: CATEGORIES_ERROR,
            payload: d?.error,
          });

        dispatch({
          type: CATEGORIES_LIST,
          payload: d,
        });
      });
  };
